import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "USD") {
  const cryptoCurrencies = ["BTC", "ETH", "HUMACOIN", "USDT"];
  
  if (cryptoCurrencies.includes(currency)) {
    return `${amount.toLocaleString(undefined, { maximumFractionDigits: 4 })} ${currency}`;
  }
  
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatNumber(num) {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toLocaleString();
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export function formatDateTime(dateString) {
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function truncateHash(hash, startChars = 8, endChars = 6) {
  if (!hash || hash.length <= startChars + endChars) return hash;
  return `${hash.slice(0, startChars)}...${hash.slice(-endChars)}`;
}

export function getStatusColor(status) {
  const colors = {
    pending: "bg-yellow-500/20 text-yellow-500 border-yellow-500/30",
    confirmed: "bg-blue-500/20 text-blue-500 border-blue-500/30",
    in_transit: "bg-purple-500/20 text-purple-500 border-purple-500/30",
    delivered: "bg-green-500/20 text-green-500 border-green-500/30",
    verified: "bg-emerald-500/20 text-emerald-500 border-emerald-500/30",
    draft: "bg-gray-500/20 text-gray-500 border-gray-500/30",
    active: "bg-blue-500/20 text-blue-500 border-blue-500/30",
    funded: "bg-amber-500/20 text-amber-500 border-amber-500/30",
    in_progress: "bg-cyan-500/20 text-cyan-500 border-cyan-500/30",
    completed: "bg-green-500/20 text-green-500 border-green-500/30",
  };
  return colors[status] || "bg-gray-500/20 text-gray-500";
}

export function getCurrencyIcon(currency) {
  const icons = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    BTC: "₿",
    ETH: "Ξ",
    USDT: "₮",
    HUMACOIN: "H",
  };
  return icons[currency] || "$";
}
